<template>
  <!-- 这是共用头部 -->
  <div class="bloom_header">
    <div class="wrap flex_style">
      <div class="header_left">
        <img @click="goToHomepage" src="../../assets/img/logo.png"/>
        <span @click="toActivite" class="ellipsis" style="max-width: 400px;width:fit-content;">{{headerTitleInner}}</span>
        <div v-if="isLogin && (isSkterUser || isExperienceMode)"  class="experience" @click="toggleModeDropdown">
          {{isExperienceMode == 1 ? $t('tabs.experienceMode') : $t('tabs.studentMode')}}
          <i v-if="isSkterUser" :class="{'el-icon-arrow-down': !modeDropdownVisible, 'el-icon-arrow-up': modeDropdownVisible}" class="moreIcon el-input__icon"></i>
          <div v-if="modeDropdownVisible && isSkterUser" class="mode-dropdown">
            <div class="mode-dropdown-menu">
              <div class="mode-dropdown-item" @click="handleModeChange('10')">{{$t('tabs.studentMode')}}</div>
              <div class="mode-dropdown-item" @click="handleModeChange('90')">{{$t('tabs.experienceMode')}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="nav_list">
        <button
          v-if="false"
          type="button"
          class="nav_ai_banxue_btn cursor"
          :aria-label="$t('aiStudyBuddy.title')"
          @click="openAiAssistantFromBloomHeader"
        >
          <img :src="bloomHeaderAiBtnSrc" alt="" draggable="false" />
        </button>
        <div class="nav_item cursor hover" @click="handleSelect(1)" :class="{active : +activeIndex === 1}">{{$t('tabs.tasks')}}</div>
        <div class="nav_item cursor hover" @click="handleSelect(5)" :class="{active : +activeIndex === 5}" v-if="activityId">
          {{$t('tabs.Plaza')}}
<!--          <img class="iconImg" src="//img.webloom.cn/img/aa5168317ec1abae5c87dc40b2413578.gif">-->
        </div>
        <div class="nav_item cursor hover" @click="getTeamInfo" :class="{active : +activeIndex === 2}" >{{$t('flowTeamHall1')}}</div>
        <div class="nav_item cursor hover" @click="handleSelect(3)" :class="{active : +activeIndex === 3}">
          <el-badge :value="ActNum" :hidden="ActNum < 1" :max="99"><span>{{$t('tabs.messages')}}</span></el-badge>
<!--          <el-badge :value="10000" :hidden="1000 < 1" :max="99"><span>{{$t('tabs.messages')}}</span></el-badge>-->
        </div>
        <!-- <div class="nav_item cursor hover" @click="handleSelect(4)" :class="{active : +activeIndex === 4}">成长星球</div> -->
        <div class="user_icon" v-if="isLogin">
          <el-popover
            popper-class="headerPopover"
            placement="bottom"
            @show="headerPopoverShow"
            trigger="hover">
            <div class="popoverCent">
              <div class="contentItem" @click="handleCommand('MyActivities')">
                <div class="itemIn" @mouseenter="contentItemMouseover">
                  <div></div>
                  <img src="https://img.webloom.cn/img/dropdownicon1.png" alt="" class="itemInIcon">
                  <img src="https://img.webloom.cn/img/dropdownicon1act.png" alt="" class="itemInIcon1">
                  <div :class="$i18n.locale !== 'zh' ? 'itemInTxtEn' : 'itemInTxt'">{{$t('mine.activity')}}</div>
                </div>
              </div>
              <div class="contentItem" @click="handleCommand('MySociety')">
                <div class="itemIn">
                  <img src="https://img.webloom.cn/img/dropdownicon2.png" alt="" class="itemInIcon">
                  <img src="https://img.webloom.cn/img/dropdownicon2act.png" alt="" class="itemInIcon1">
                  <div :class="$i18n.locale !== 'zh' ? 'itemInTxtEn' : 'itemInTxt'">{{$t('mine.society')}}</div>
                </div>
              </div>
              <div class="contentItem" @click="handleCommand('battleCenter')">
                <div class="itemIn">
                  <img src="https://img.webloom.cn/img/dropdownicon3.png" alt="" class="itemInIcon">
                  <img src="https://img.webloom.cn/img/dropdownicon3act.png" alt="" class="itemInIcon1">
                  <div :class="$i18n.locale !== 'zh' ? 'itemInTxtEn' : 'itemInTxt'">{{$t('mine.battleCenter')}}</div>
                </div>
              </div>
              <div class="contentItem" @click="handleCommand('MyOrder')">
                <div class="itemIn">
                  <img src="https://img.webloom.cn/img/dropdownicon4.png" alt="" class="itemInIcon">
                  <img src="https://img.webloom.cn/img/dropdownicon4act.png" alt="" class="itemInIcon1">
                  <div :class="$i18n.locale !== 'zh' ? 'itemInTxtEn' : 'itemInTxt'">{{$t('mine.orders')}}</div>
                </div>
              </div>
              <div class="contentItem" @click="handleCommand('MessageUs')">
                <div class="itemIn">
                  <img src="https://img.webloom.cn/Img/gondan0.png" alt="" class="itemInIcon">
                  <img src="https://img.webloom.cn/Img/gondan1.png" alt="" class="itemInIcon1">
                  <div :class="$i18n.locale !== 'zh' ? 'itemInTxtEn' : 'itemInTxt'">
                    {{$t('mine.messageUs')}}
                    <div class="TicketNum" v-if="TicketNum> 0">{{TicketNum > 99 ? '99+' : TicketNum}}</div>
                    <!--<div class="TicketNum">9</div>-->
                  </div>
                </div>
              </div>
              <div class="contentItem"  @click="handleCommand('setting')">
                <div class="itemIn">
                  <img src="https://img.webloom.cn/img/dropdownicon5.png" alt="" class="itemInIcon">
                  <img src="https://img.webloom.cn/img/dropdownicon5act.png" alt="" class="itemInIcon1">
                  <div :class="$i18n.locale !== 'zh' ? 'itemInTxtEn' : 'itemInTxt'">{{$t('mine.setting')}}</div>
                </div>
              </div>
              <div class="contentItem exitBox"  @click="handleCommand('logout')">
                <div class="itemIn">
                  <img src="https://img.webloom.cn/img/dropdownicon6.png" alt="" class="itemInIcon">
                  <img src="https://img.webloom.cn/img/dropdownicon6act.png" alt="" class="itemInIcon1">
                  <div :class="$i18n.locale !== 'zh' ? 'itemInTxtEn exit' : 'itemInTxt exit'">{{$t('mine.quite')}}</div>
                </div>
              </div>
            </div>
            <div class="img_container" @click="checkStatu" slot="reference">
              <img :src="hearderImg" onerror="this.src='//img.webloom.cn/img/logo/default-user.png';this.onerror=null" />
            </div>
          </el-popover>
<!--          <el-dropdown @command="handleCommand" placement="bottom">-->
<!--            <div class="img_container"  @click="checkStatu">-->
<!--              <img :src="hearderImg" onerror="this.src='//img.webloom.cn/img/logo/default-user.png';this.onerror=null" />-->
<!--            </div>-->
<!--            <el-dropdown-menu slot="dropdown" class="drop_position">-->
<!--              <el-dropdown-item command="EventPlaza_MineList">{{$t('mine.home')}}</el-dropdown-item>-->
<!--              <el-dropdown-item command="MySociety">{{$t('mine.society')}}</el-dropdown-item>-->
<!--              <el-dropdown-item command="MyActivities">{{$t('mine.activity')}}</el-dropdown-item>-->
<!--              <el-dropdown-item command="BattleCenter">{{$t('mine.battleCenter')}}</el-dropdown-item>-->
<!--              <el-dropdown-item command="MyOrder">{{$t('mine.orders')}}</el-dropdown-item>-->
<!--              <el-dropdown-item command="MycouponList">{{$t('mine.coupons')}}</el-dropdown-item>-->
<!--              <el-dropdown-item command="CourseDetails">{{$t('mine.authenticationCenter')}}</el-dropdown-item>-->
<!--              <el-dropdown-item command="UserCenter">{{$t('mine.setting')}}</el-dropdown-item>-->
<!--              <el-dropdown-item command="logout">{{$t('mine.quite')}}</el-dropdown-item>-->
<!--            </el-dropdown-menu>-->
<!--          </el-dropdown>-->
        </div>
        <div v-else class="user_login" @click="handleLogin">{{$t('tabs.loginOrRes')}}</div>
      </div>
    </div>
    <div class="change-lang cursor" @click="changeLang">
      <span :class="{active: $i18n.locale == 'en'}">EN</span>/<span :class="{active: $i18n.locale != 'en'}">中</span>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapState({
      isLogin: state => state.login.isLogin,
      ActNum: state => state.login.ActNum
    }),
    /** Bloom 头部伴学入口：中英文切图 */
    bloomHeaderAiBtnSrc () {
      return this.$i18n.locale === 'en'
        ? 'https://img.webloom.cn/Img/banxuebtnEn.webp'
        : 'https://img.webloom.cn/Img/banxuebtnCn.webp'
    }
  },
  props: {
    headTitle: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      TicketNum: 0,
      isExperienceMode: 0,
      activityId: '',
      activeIndex: 1,
      hearderImg: '',
      messageCount: 0,
      headerTitleInner: '',
      activeTpye: '',
      seasonId: '',
      contestId: '',
      userId: '',
      canGetNum: true,
      modeDropdownVisible: false,
      isSkterUser: false
      // ActNum: 9999
    }
  },
  // inject: ['MtaH5'],
  methods: {
    headerPopoverShow () {
      if (!this.canGetNum) {
        return
      }
      this.canGetNum = false
      let data = {}
      this.$api.purePost('TICKET_STUDENT_UNM', data, (res) => {
        this.TicketNum = res.data || 0
        setTimeout(() => {
          this.canGetNum = true
        })
      })
    },
    contentItemMouseover (e) {
      console.log(e, 'contentItemMouseover')
    },
    // 获取头部消息数量
    getNoticeInfo () {
      let data = {
        businessId: this.$route.params.seasonId || this.$route.query.seasonId || this.seasonId
      }
      this.$api.post('GET_UNREADCOUNT', data, (res) => {
        this.noticeNo = res.data.noticeNum || 0
        // 更新活动消息
        let activityNum = res.data.activityNum || 0
        let num = activityNum + this.noticeNo
        this.$store.commit('setActNum', num)
      })
    },
    // 切换中英文
    changeLang () {
      this.lang = this.$i18n.locale === 'en' ? 'zh' : 'en'
      this.$i18n.locale = this.lang
      this.$nextTick(() => {
        this.$utils.cache('bloom:lang', this.$i18n.locale)
      })
    },
    /** 伴学助手：与全局 header-box 共用面板（事件总线） */
    openAiAssistantFromBloomHeader () {
      if (this.$bus) {
        this.$bus.$emit('open-ai-assistant-from-bloom-header')
      }
    },
    // 选择当前active页签
    handleSelect (selected) {
      this.activeIndex = selected
      if (selected === 1) {
        let section = this.$utils.sessionCache('changeSection' + this.seasonId) || this.$route.query.section || 0
        let url = `/taskList/${this.seasonId}?contestId=${this.contestId}&section=${section}`
        this.$router.push(url)
      } else if (selected === 2) {
        let t = new Date().getTime()
        let url = `/teamHomepage?contestId=${this.contestId}&seasonId=${this.seasonId}&t=${t}`
        this.$router.push(url)
      } else if (selected === 3) {
        this.$router.push({
          path: '/teamMessage',
          query: {
            topicId: this.$route.params.seasonId || this.$route.query.seasonId || this.seasonId,
            contestId: this.$route.query.contestId || this.contestId,
            type: 0
          }
        })
      } else if (selected === 4) {
        this.$router.push({
          name: 'PlanetRecommend'
        })
      } else if (selected === 5) {
        let querys = {}
        if (this.$utils.cache('userData')) {
          querys.uid = JSON.parse(this.$utils.cache('userData')).userId
        }
        this.$api.post('PLAZA_COMMON_ACTIVITIES', {activityStatus: 1}, (res) => {
          let activitySquares = res.data.activitySquares || []
          let thisPage = activitySquares.filter(activity => {
            return this.activityId === activity.activityId
          })[0] || {}
          this.$utils.CzcTrackEvent('活动任务列表', `进入${thisPage.squareName}页面`)
        })
        querys.ua = navigator.userAgent
        querys.contestid = this.$route.query.contestId
        // this.MtaH5.clickStat('navigation_entry_click', querys)
        this.$router.push({
          path: '/EventPlaza/home',
          query: {
            activityId: this.activityId
          }
        })
      }
    },
    // 跳转首页
    goToHomepage () {
      // window.location.href = 'https://www.webloom.cn/competition/CCD'
      window.location.href = '/'
    },
    toActivite () {
      window.location.href = `/bloom_web/#/GameData/${this.activeTpye}?contestId=${this.contestId}&seasonId=${this.seasonId}`
    },
    // 弹出登录框
    handleLogin () {
      this.$_Login()
    },
    handleCommand (command) {
      this.$utils.CzcTrackEvent(this.$route.name, '头像下拉框', command)
      if (command === 'logout') {
        this.logout()
      } else if (command === 'EventPlaza_MineList') {
        this.activeIndex = 0
        this.$router.push({
          name: 'EventPlaza_MineList',
          query: {
            t: new Date().getTime()
          }
        })
      } else if (command === 'MySociety') {
        this.activeIndex = 0
        this.$router.push({
          name: 'MySociety',
          query: {
            t: new Date().getTime()
          }
        })
      } else if (command === 'CourseDetails') {
        this.activeIndex = 0
        this.$router.push(`/CourseDetails`)
      } else if (command === 'battleCenter') {
        this.activeIndex = 0
        this.$router.push(`/BattleCenter`)
        // this.$router.push(`/BattleCenter`)
      } else if (command === 'setting') {
        this.activeIndex = 0
        this.$router.push(`/PersonalCenter/UserCenter`)
      } else if (command === 'MessageUs') {
        this.$router.push(`/workOrder`)
      } else {
        console.log(7777777777777)
        if (command === 'UserCenter') this.$utils.CzcTrackEvent('个人中心', '进入个人资料')
        if (command === 'MyActivities') this.$utils.CzcTrackEvent('首页', '点击我的活动入口')
        this.activeIndex = 0
        this.$router.push(`/PersonalCenter/${command}`)
      }
    },
    ...mapMutations([
      'set_isLogin'
    ]),
    // 退出登录
    logout () {
      this.$api.post('USER_LOGOUT', '', (res) => {
        window.localStorage.removeItem('userData')
        this.$store.commit('set_isLogin', false)
        this.$emit('logout')
        window.location.href = `/bloom_web/#/`
      })
    },
    init () {
      if (this.$route.name === 'teamMessage') {
        this.getSeasonInfo()
      }
      if (this.$route.name === 'TaskList') {
        this.activeIndex = 1
      } else if (this.$route.name === 'teamHomepage' || this.$route.name === 'teamFormationHall') {
        this.activeIndex = 2
      } else if (this.$route.name === 'teamMessage' || this.$route.name === 'NoticeInfo') {
        this.activeIndex = 3
      }
      if (this.$route.name !== 'TaskList') {
        this.getNoticeInfo()
      }
      let userData = JSON.parse(this.$utils.cache('userData'))
      if (this.$route.name === 'TaskList') {

      }
      if (userData) {
        this.hearderImg = userData.portraitPath || ''
        this.userId = userData.userId || ''
        this.set_isLogin(true)
      }
    },
    // 切换模式下拉框显示状态
    toggleModeDropdown () {
      this.modeDropdownVisible = !this.modeDropdownVisible
    },
    // 处理模式切换
    handleModeChange (mode) {
      const newMode = parseInt(mode)
      if (newMode !== this.isExperienceMode) {
        let data = {
          seasonId: this.seasonId,
          mode: newMode
        }
        this.$api.post('NEW_TASKRELATION_SETMODE', data, (res) => {
          this.isExperienceMode = newMode === 90 ? 1 : 0
          this.$utils.sessionCache('isExperienceMode' + '', JSON.stringify(this.isExperienceMode))
          // 刷新页面以应用模式切换
          window.location.reload()
        })
      }
      this.modeDropdownVisible = false
    },
    // 点击外部关闭下拉菜单
    handleClickOutside (event) {
      // 检查点击事件是否发生在经验模式按钮或下拉菜单内部
      const experienceElement = document.querySelector('.experience')
      if (experienceElement && !experienceElement.contains(event.target)) {
        this.modeDropdownVisible = false
      }
    },
    getSeasonInfo () {
      let obj = {
        seasonId: this.seasonId
      }
      this.$getCommon('NEW_CONTEST_SEASON_GETINFO', obj).then(({ data }) => {
        this.activityId = data.activityId || ''
        this.activeTpye = data.nameEn
        this.headerTitleInner = `${data.nameEn} ${data.name}`
        this.$utils.cache('seasonId', String(data.seasonId))
        this.$utils.sessionCache('contestInfo', JSON.stringify(data))
        this.seasonId = data.seasonId
        this.contestId = data.contestId
      })
    },
    // 获取未读消息数
    getUnreadCount () {
      // if (!this.seasonId) return
      // let data = {
      //   businessId: this.seasonId
      // }
      // this.$api.post('GET_UNREADCOUNT', data, (res) => {
      //   this.messageCount = res.data.unReadCount
      // })
    },
    checkStatu () {
      this.$api.post('LOGIN_STATE', {}, () => {
        this.init()
      }, () => {
        this.init()
      })
    },
    // 获取团队信息
    getTeamInfo () {
      if (this.$route.name === 'teamFormationHall') return
      this.activeIndex = 2
      let data = {
        seasonId: this.$route.params.seasonId || this.$route.query.seasonId || this.seasonId
      }
      this.$api.post('TEAM_DETAIL', data, (res) => {
        this.teamInfo = {...res.data}
        // 存缓存
        localStorage.setItem('HeaderTeamInfo' + this.userId, JSON.stringify(this.teamInfo))
        // * 1 跳转至组队大厅
        // * 2 跳转至组队大厅，任务结束缺省页
        // * 3 跳转至团队详情
        if (+this.teamInfo.jumpType === 3) {
          this.handleSelect(2)
        } else  {
          this.$router.push({
            path: '/teamFormationHall',
            query: {
              seasonId: this.seasonId,
              taskRelationId: this.taskRelationId
            }
          })
        }
      }, (err) => {
        if (err.code === 45101) {
          this.$router.replace({
            path: '/NoAuthorityPage'
          })
        }
      })
    }
  },
  created () {
    // 获取缓存中的seasonId
    let season = this.$utils.cache('seasonId') ? this.$utils.cache('seasonId') : ''
    // 记录缓存和链接值是否相同
    let isSame = false
    // 对比缓存中的seasonId和链接上的seasonId是否相同，不同则更改缓存中的seasonId
    let routerSeason = this.$route.query && this.$route.query.seasonId ? this.$route.query.seasonId : this.$route.params && this.$route.params.seasonId ? this.$route.params.seasonId : ''
    if (routerSeason && season !== routerSeason) {
      this.seasonId = routerSeason
      this.$utils.cache('seasonId', String(routerSeason))
    } else {
      isSame = true
      this.seasonId = this.$utils.cache('seasonId')
    }

    if (this.$route.query.contestId) {
      this.contestId = this.$route.query.contestId
      this.$utils.cache('contestId', this.$route.query.contestId)
    } else {
      this.contestId = this.$utils.cache('contestId')
    }
    // seasonId存在且 缓存和链接值不同或者contestInfo不存在 拿seasonId详情
    if (this.seasonId && (!isSame || !this.$utils.sessionCache('contestInfo'))) {
      this.getSeasonInfo()
    } else {
      // 如果缓存存在则值从缓存中取
      if (!this.headerTitleInner && this.$utils.sessionCache('contestInfo')) {
        let data = JSON.parse(this.$utils.sessionCache('contestInfo'))
        this.activityId = data.activityId || ''
        this.activeTpye = data.nameEn
        this.headerTitleInner = `${data.nameEn} ${data.name}`
        this.$utils.cache('seasonId', String(data.seasonId))
        this.$utils.sessionCache('contestInfo', JSON.stringify(data))
        this.seasonId = data.seasonId
        this.contestId = data.contestId
      }
    }
    this.init()
    // 由于线上考试。暂时注释，下个版重新放开
    this.getUnreadCount()
  },
  mounted () {
    let seasonId = ''
    let routerSeason = this.$route.query && this.$route.query.seasonId ? this.$route.query.seasonId : this.$route.params && this.$route.params.seasonId ? this.$route.params.seasonId : ''
    if (routerSeason) {
      seasonId = routerSeason
    } else {
      seasonId = this.$utils.cache('seasonId') || ''
    }
    if (seasonId) {
      this.$api.post('NEW_TASKRELATION_GETMODE', { seasonId }, res => {
        this.isExperienceMode = res.data.isExperience || 0
        this.isSkterUser = res.data.isSkter || false
        this.$utils.sessionCache('isExperienceMode' + '', JSON.stringify(res.data))
      })
    } else {
      this.isExperienceMode = this.$utils.sessionCache('isExperienceMode')
    }
    
    // 添加全局点击事件监听器，点击外部关闭下拉菜单
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy () {
    // 移除全局点击事件监听器
    document.removeEventListener('click', this.handleClickOutside)
  }
}
</script>

<style lang="less" scoped>
.bloom_header {
  height: 60px;
  width: 100%;
  background-color: #fff;
  border-bottom: solid 1px #e6e6e6;
  box-sizing: border-box;
  position: -webkit-sticky;
  position: sticky;
  z-index: 1000;
  top: 0;
  //top: 36px;
  .flex_style {
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .header_left {
      display: flex;
      align-items: center;
      .experience{
        white-space: nowrap;
        margin-left: 48px;
        margin-right: 48px;
        padding: 4px 8px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #7F8690;
        line-height: 22px;
        text-align: right;
        font-style: normal;
        background: #EBEFF6;
        border-radius: 4px;
        cursor: pointer;
        position: relative;
        .moreIcon{
          font-size: 16px;
          line-height: 22px;
        }
        .mode-dropdown {
          position: absolute;
          top: 100%;
          left: 50%;
          transform: translateX(-50%);
          margin-top: 4px;
          z-index: 1001;
          .mode-dropdown-menu {
            background: #ffffff;
            border: 1px solid #e4e7ed;
            border-radius: 4px;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
            min-width: 120px;
            padding: 4px 0;
            .mode-dropdown-item {
              text-align: center;
              padding: 10px 20px;
              cursor: pointer;
              white-space: nowrap;
              &:hover {
                background: #f5f7fa;
                color: #296BFF;
              }
            }
          }
        }
      }
      img {
        height: 40px;
        width: 40px;
        cursor: pointer;
      }
      span {
        display: inline-block;
        margin-left: 20px;
        height: 22px;
        font-size: 22px;
        border-left: 1px solid #D8D8D8;
        padding-left: 20px;
        line-height: 22px;
        font-weight: 600;
        cursor: pointer;
      }
    }
    .nav_list {
      display: flex;
      align-items: center;
      width: auto;
      min-width: 584px;
      max-width: 720px;
      justify-content: space-between;
      .nav_ai_banxue_btn {
        border: none;
        padding: 0;
        margin: 0;
        background: transparent;
        line-height: 0;
        flex-shrink: 0;
        display: inline-flex;
        align-items: center;
        align-self: center;
        img {
          height: 28px;
          width: auto;
          max-width: 200px;
          display: block;
        }
        &:hover {
          opacity: 0.9;
        }
      }
      .nav_item{
        width: fit-content;
        white-space: nowrap;
        display: inline-block;
        position: relative;
        &.active {
          color: #296BFF;
        }
        &.disabled {
          color: #C0C4CC;
        }
        &.hover {
          &:hover {
            color: #296BFF;
          }
        }
        .iconImg{
          position: absolute;
          top: -6px;
          left: -30px;
          line-height: 0;
          font-size: 0;
        }
      }
      .user_login {
        display: inline-block;
        // margin-left: 80px;
        cursor: pointer;
      }
      .user_icon {
        cursor: pointer;
        display: inline-block;
        // margin-left: 80px;
        margin-right: 20px;
        border: 1px solid #d8d8d8;
        overflow: hidden;
        height: 40px;
        width: 40px;
        min-width: 40px;
        min-height: 40px;
        border-radius: 50%;
        box-sizing: border-box;
        .img_container {
          height: 40px;
          width: 40px;
          min-width: 40px;
          min-height: 40px;
          overflow: hidden;
          box-sizing: border-box;
          border-radius: 50%;
          display: flex;
          img {
            width: 40px;
            align-self: center;
          }
        }
        .drop_position {
          margin-right: -20px !important;
        }
      }
    }
  }
.img_box {
  display: inline-block;
  margin-top: 14px;
  margin: 14px 20px 14px 5px;
  height: 32px;
  width: 32px;
  border-radius: 50%;
  overflow: hidden;
  box-sizing: border-box;
  border: 1px solid  #e6e6e6;
  img {
    height: 100%;
    width: 100%;
  }
}
.change-lang{
  position: absolute;
  right: 20px;
  top: 20px;
  font-size: 13px;
  color: #959595;
  span {
    &.active {
      color: #212121;
    }
  }
}
  .itemInTxt {
    width: fit-content;
    position: relative;
    .TicketNum {
      min-width: 16px;
      height: 16px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #FFFFFF;
      line-height: 17px;
      text-align: center;
      font-style: normal;
      box-sizing: border-box;
      background: #FF2F49;
      position: absolute;
      top: -8px;
      right: -4px;;
      border-radius: 16px;
      padding: 0 4px!important;
    }
  }
  .itemInTxtEn {
    width: fit-content;
    position: relative;
    TicketNum {
      min-width: 8px;
      height: 16px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #FFFFFF;
      line-height: 17px;
      text-align: center;
      font-style: normal;
      background: #FF2F49;
      position: absolute;
      top: -8px;
      right: 24px;
      border-radius: 16px;
      padding: 0 4px!important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/header.vue